import { createSelector } from 'reselect';
import { simplifyPickupBopisHeaderTextPdpSelector } from 'selectors/testTarget/offers/simplifyPickupBopisHeaderTextPdp/simplifyPickupBopisHeaderTextPdpSelector';

const activeSelector = createSelector(
    simplifyPickupBopisHeaderTextPdpSelector,
    simplifyPickupBopisHeaderTextPdp => !!simplifyPickupBopisHeaderTextPdp.active
);

export { activeSelector };
